import React from 'react';
import { useTheme } from 'styled-components';
import * as Styled from './PricingIndicatorIconText.styled';
import { Text } from '../../ToolkitV2/Text/Text';

import {
  ArrowDownCircleIc,
  ArrowForwardCircleIc,
  ArrowUpCircleIc,
} from '@dsch/dd-icons';

export type PricingIndicatorStatus = 'ABOVE' | 'SAME' | 'BELOW';

type Props = {
  status: PricingIndicatorStatus;
  underline?: boolean;
  textSize?: 'B14' | 'M14';
};

export const PricingIndicatorIconText = ({
  status,
  underline,
  textSize = 'B14',
}: Props) => {
  const theme = useTheme();

  const statusStates = {
    ABOVE: {
      label: 'Above avg.',
      icon: (
        <ArrowUpCircleIc
          color={theme.donedeal.colors.GREY}
          width="16"
          height="16"
        />
      ),
    },
    SAME: {
      label: 'At avg.',
      icon: (
        <ArrowForwardCircleIc
          color={theme.donedeal.colors.ORANGE_LIGHT}
          width="16"
          height="16"
        />
      ),
    },
    BELOW: {
      label: 'Below avg.',
      icon: (
        <ArrowDownCircleIc
          color={theme.donedeal.colors.GREEN}
          width="16"
          height="16"
        />
      ),
    },
  } as const;

  const state = statusStates[status];

  if (!state) return null;

  const { label, icon } = state;

  return (
    <Styled.Container>
      <span aria-hidden="true">{icon}</span>
      <Text
        size={textSize}
        forwardedAs="span"
        color={'GREY_DARK'}
        underline={underline ? 'dotted' : false}
      >
        {label}
      </Text>
    </Styled.Container>
  );
};
